export const URLS={
    user:{
        auth:{
            login:'/server/userauth/login',
            logout:'/server/userauth/logout'
        },
        info:'/server/user/info',        
    },
    cachBook:{
        finalCash:'/server/cashbook/finalCash',
        transitions:'/server/cashbook/book',

    },
    ws:{
        getJwt:'/server/chatsinfo/wsjwt',
        chats:'/server/ws/chat'
    },
    chatsInfo:{
        number:'/server/chatsinfo/numbers',
        v8:'/server/chatsinfo/v8logins',
        states:'/server/chatsinfo/states'
    },
    bulkState:{
        broadcast:'/server/bulkState/broadcastChangeState'
    },
    templateJobs:{
        analytics:'/server/templateJobs/analytics',
        list:'/server/templateJobs/list',
        retry131049:'/server/templateJobs/retry131049',
    },
    fgtsChat:{
        updateState:'/server/support/updateFgtsChatState',
        updateChatState:'/server/support/updateChatState',
        clientInfo:(chatId:number)=>`/server/support/clientInfo/${chatId}`,
        updateClientData:'/server/support/updateClientData',
        cltConsults:(chatId:number)=>`/server/support/cltConsults/${chatId}`,
        fgtsConsults:(chatId:number)=>`/server/support/fgtsConsults/${chatId}`,
        cltConsultErrors:(chatId:number)=>`/server/support/cltConsultErrors/${chatId}`,
        botErrors:(chatId:number)=>`/server/support/botErrors/${chatId}`,
        cltShotDebug:(chatId:number)=>`/server/support/cltShotDebug/${chatId}`,
        dataprevInfo:(chatId:number)=>`/server/support/dataprevInfo/${chatId}`,
        reconsultMargin:'/server/support/reconsultMargin',
        generateProposal:'/server/support/generateProposal',
    },
    wa:{
        sendText:'/server/wa/sendText',
    },
    clt:{
       list:'/server/clt/supportRow/list',
       addSupport:'/server/clt/supportRow/addSupport/',
       updateStatus:'/server/clt/supportRow/updateStatus/',
       botPropostals:'/server/clt/bot/propostals',
       botPropostal:'/server/clt/bot/propostal',
       setSupport:'/server/clt/bot/setSupport',
       rowInfo:'/server/clt/supportRow/info',
    },
    propostals:{
       getInfo:'/server/propostals/propostalInfo',
       renewLink:'/server/propostals/renewLink',
       resolveDocument:'/server/propostals/pedency/solveDocument',
       resolvePix:'/server/propostals/pedency/solvePix',
       get:'/server/propostals/propostals',
       search:(type:string,sr:string)=>`/server/propostals/propostals/search/${type}/${sr}`,
       conversation:(clientPhone:string,rootPhone:string)=>`/server/propostals/propostals/conversation/${clientPhone}/${rootPhone}`,
       getComplete:'/server/propostals/propostalsComplete',
       setSupport:'/server/propostals/porpostalSupport'
    },
    testChat:{
        message:'/server/testchat/message',
        reset:'/server/testchat/reset',
        poll:(phone:string)=>`/server/testchat/poll/${phone}`,
        state:(phone:string)=>`/server/testchat/state/${phone}`,
    },
    solve:{
        uploadDocs:'/server/solve/uploadDocs',
        hasDoc:'/server/solve/hasdoc',
        hasPendency:'/server/solve/haspendency',
        resolve:'/server/solve/solvependency'
    },
    admin:{
        accounts:{
            wa:{
                create:'/server/admin/accounts/wa/create',
                list:'/server/admin/accounts/wa/list',
                get:(id:number)=>`/server/admin/accounts/wa/${id}`,
                update:(id:number)=>`/server/admin/accounts/wa/${id}`,
                delete:(id:number)=>`/server/admin/accounts/wa/${id}`,
                toggle:(id:number)=>`/server/admin/accounts/wa/${id}/toggle`,
                toggleShots:(id:number)=>`/server/admin/accounts/wa/${id}/toggle-shots`,
            },
            ig:{
                create:'/server/admin/accounts/ig/create',
                list:'/server/admin/accounts/ig/list',
                oauthUrl:'/server/admin/accounts/ig/oauth-url',
                get:(id:number)=>`/server/admin/accounts/ig/${id}`,
                update:(id:number)=>`/server/admin/accounts/ig/${id}`,
                delete:(id:number)=>`/server/admin/accounts/ig/${id}`,
                toggle:(id:number)=>`/server/admin/accounts/ig/${id}/toggle`,
            },
            evolution:{
                create:'/server/admin/accounts/evolution/create',
                list:'/server/admin/accounts/evolution/list',
                get:(id:number)=>`/server/admin/accounts/evolution/${id}`,
                update:(id:number)=>`/server/admin/accounts/evolution/${id}`,
                delete:(id:number)=>`/server/admin/accounts/evolution/${id}`,
                toggle:(id:number)=>`/server/admin/accounts/evolution/${id}/toggle`,
                test:(id:number)=>`/server/admin/accounts/evolution/${id}/test`,
            },
            telegram:{
                create:'/server/admin/accounts/telegram/create',
                list:'/server/admin/accounts/telegram/list',
                get:(id:number)=>`/server/admin/accounts/telegram/${id}`,
                update:(id:number)=>`/server/admin/accounts/telegram/${id}`,
                delete:(id:number)=>`/server/admin/accounts/telegram/${id}`,
                toggle:(id:number)=>`/server/admin/accounts/telegram/${id}/toggle`,
                test:(id:number)=>`/server/admin/accounts/telegram/${id}/test`,
            },
            v8:{
                list:'/server/admin/accounts/v8/list',
            }
        },
        notifications:{
            // Aviso interno no Telegram quando uma proposta FGTS/CLT é paga (valor + comissão).
            telegramPaid:{
                get:'/server/admin/notifications/telegram-paid/get',
                set:'/server/admin/notifications/telegram-paid/set',
                test:'/server/admin/notifications/telegram-paid/test',
            }
        }
    }
}